module.exports = __webpack_public_path__ + "static/media/Assets-01-Vienna-Town-Hall-02.e7b1fd8d.mp4";